export enum WebEngageEventNames {
  AMC_SHOWN_PLAN_CARDS = 'AMC_Shown_Plan_Cards',
  AMC_TIER_SELECTION_SCREEN_LANDED = 'AMC Tier Selection Screen Landed',
  AMC_PLANS_SCREEN_LANDED = 'AMC Plans Screen Landed',
  AMC_PAYMENT_STATUS_SCREEN_LANDED = 'AMC Payment Status Screen Landed',
  AMC_PAYMENT_CANCEL = 'AMC Payment Cancel',
  AMC_PAYMENT_SUCCESS = 'AMC Payment Success',
  AMC_PAYMENT_FAILURE = 'AMC Payment Failure',
  AMC_PLAN_SELECTED = 'AMC Plan Selected',
  AMC_PLAN_SCREEN_COUPON_APPLIED = 'AMC Plan Screen Coupon Applied',
  AMC_PLAN_SCREEN_ST_ASSIST_INFO_FILLED = 'AMC Plan Screen ST Assist Info filled',
  AMC_TIER_SELECTED = 'AMC Tier Selected',
  TERMS_AND_CONDITIONS_CHECKBOX_SELECTED = 'Terms And Conditions Checkbox Selected',
  TERMS_AND_CONDITIONS_LINK_CLICKED = 'Terms And Conditions Link Clicked',
  BUY_AMC_PLAN_CLICKED = 'Buy AMC Plan Clicked',
  AMC_COUPON_POPUP_SCREEN_LANDED = 'AMC Coupon Popup Screen Landed',
  AMC_COUPON_POPUP_SCREEN_COUPON_VERIFIED = 'AMC Coupon Popup Screen Coupon Verified',
  AMC_COUPON_POPUP_SCREEN_COUPON_TYPING_STARTED = 'AMC Coupon Popup Screen Coupon Typing Started',
  AMC_COUPON_POPUP_SCREEN_OTP_TYPING_STARTED = 'AMC Coupon Popup Screen OTP Typing Started',
  AMC_COUPON_POPUP_SCREEN_OTP_VERIFIED = 'AMC Coupon Popup Screen OTP Verified',
  PRODUCT_SELECTION_POPUP_OPENED = 'Product Selection Pop up opened',
  PRODUCT_SELECTION_POPUP_DEVICE_SELECTED = 'Product Selection Pop Up Device Selected',
  FAQ_CLICKED = 'FAQ Clicked',
  INFO_BUTTON_CLICKED = 'Info Button Clicked',
  SERVICE_BOOKING_SCREEN_OPENED = 'Service Booking Screen Opened',
  SR_VIEW_MORE_CLICK = 'Service Booking Screen View More Details Clicked',
  BOOK_A_SERVICE_CLICKED = 'Book A Service Clicked',
  BOOK_A_SERVICE_SCREEN_OPENED = 'Book A Service Screen Opened',
  SERVICE_OPTION_SELECTED = 'Service Option Selected',
  SERVICE_DEFECT_TYPE_SCREEN_OPENED = 'Service Defect Type Screen Opened',
  SERVICE_DEFECT_TYPE_SELECTED = 'Service Defect Type Selected',
  SERVICE_DEFECT_SCREEN_NEXT_CLICKED = 'Service Defect Screen Next Clicked',
  REINSTALL_SCREEN_OPENED = 'Re-install Address Selection Screen Opened',
  REINSTALL_SCREEN_NEXT_CLICKED = 'Re-install Address Selection Screen Next Clicked',
  BOOK_A_SLOT_SCREEN_OPENED = 'Book A Slot Screen Opened',
  BOOK_A_SLOT_NEXT_CLICKED = 'Book A Slot Screen Next Clicked',
  SERVICE_REQ_SUMMARY_SCREEN_OPENED = 'Service Request Summary Screen Opened',
  SERVICE_REQ_SUMMARY_SCREEN_NEXT_CLICKED = 'Service Request Summary Screen Submit Request Clicked',
  DEVICE_DETAILS_SCREEN_OPENED = 'Device Details Screen Opened',
  AMC_DOC_DOWNLOAD_CLICKED = 'AMC Document Download Clicked',
  SERVICE_REQ_STATUS_SCREEN_OPENED = 'Service Request Status Screen Opened',
  SERVICE_REQ_STATUS_CANCEL_CLICKED = 'Service Request Status Screen Cancel Clicked',
  SERVICE_REQ_STATUS_RESCHEDULE_CLICKED = 'Service Request Status Screen Reschedule Clicked',
}

export enum CustomerType {
  OW = 'ow',
  OC = 'oc',
  IW = 'iw',
  IC = 'ic',
}

export enum AppScreens {
  HOMEPAGE = 'HomePage',
  AMC_TIER_SELECTION_SCREEN = 'AMC Tier Selection Screen',
  AMC_PRODUCT_LISTING_SCREEN = 'AMC Product Listing Screen',
  AMC_PAYMENT_CANCEL = 'AMC Payment Cancel',
  AMC_PAYMENT_SUCCESS = 'AMC Payment Success',
  AMC_PAYMENT_FAILURE = 'AMC Payment Failure',
  PRODUCT_SELECTION_POPUP_SCREEN = 'Product Selection Popup Screen',
  SERVICE_REQUEST_SCREEN = 'Service Request Screen',
  AMC_PLANS_SCREEN = 'AMC Plans Screen',
  SERVICE_BOOKING_SCREEN = 'Service Booking Screen',
  BOOK_A_SERVICE_SCREEN = 'Book A Service Screen',
  SERVICE_DEFECT_TYPE_SCREEN = 'Service Defect Type Screen',
  REINSTALL_SCREEN = 'Re-install Address Selection Screen',
  BOOK_A_SLOT_SCREEN = 'Book A Slot Screen',
  SERVICE_REQUEST_SUMMARY_SCREEN = 'Service Request Summary Screen',
  DEVICE_DETAILS_SCREEN = 'Device Details Screen',
  SERVICE_STATUS_SCREEN = 'Service Status Screen',
}

export type dateSelectionMethod = 'Quick View' | 'Calendar';
export type boolDesc = 'Yes' | 'No';
interface WebEngagePageSpecificEventData {
  buy_amc_visible: boolean;
  product_selected: string;
  product_flag: string;
  tiers_visible: string;
  amc_tier: string;
  recommended_flag: boolean;
  tier_with_recommended_flag: string;
  info_button_card_title: string;
  scheduling_automation_flow: boolDesc;
  tab?: 'Open' | 'Closed';
  service_request_number?: string;
  service_type?: string;
  mandatory_service_open: boolDesc;
  service_request_open?: boolDesc;
  product_id: string;
  defect_selected: string;
  amc_plan_duration: string;
  amc_plan_value: number;
  amc_plan_discount: number;
  additional_remark_filled: boolDesc;
  additional_remark: string;
  user_current_address_checkbox: 'Checked' | 'Unchecked';
  current_timestamp: number;
  available_slots: string;
  current_time_vs_earliest_available_slot: number;
  reschedule: boolDesc;
  time_slot_selected: string;
  date_selected: string;
  date_selection_method: dateSelectionMethod;
  amc_plan_valid_upto: string;
  amc_plan_valid_from: string;
  mandatory_service_available: number;
  mandatory_service_availed: number;
  status?: string;
  reason_code?: string;
  isAMCPromoEnabled?: boolean;
  ab_test?: string;
}

export interface WebEngageCommonEventData {
  navigated_from?: AppScreens;
  loggedin?: boolean;
  existing_user?: boolean;
  customer_type?: CustomerType | string;
  dashboard_screen_view?: 'mcc' | 'scc';
  amc_multi_tier_flow: 'Yes' | 'No';
  customer_code?: string;
}

export interface WebEngageEventData
  extends WebEngageCommonEventData,
    Partial<WebEngagePageSpecificEventData> {}

export interface WebEngage {
  init: (key: string) => void;
  track: (eventName: WebEngageEventNames, eventData: WebEngageEventData) => void;
  user: {
    login: (key: string) => void;
    setAttribute: (key: string, value: string) => void;
  };
}
